import { render } from "./mvt-forgetpassword.vue?vue&type=template&id=62f5a2df"
import script from "./mvt-forgetpassword.js?vue&type=script&lang=js"
export * from "./mvt-forgetpassword.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__